import { useContext } from 'react';
import { GlobalContext } from 'store/context/GlobalContext';
import Icons from 'components/Icons';
import { useGoogleLogin } from '@react-oauth/google';
// import { useGoogleOneTapLogin } from '@react-oauth/google';
// import jwt_decode from "jwt-decode";
// import { GoogleLogin } from '@react-oauth/google';
import useGa from 'hooks/useGa';


const GoogleLoginButton = ({ callback, className, sx, text, autoLoad, isSignedIn, defaultIcon }) => {
    const context = useContext(GlobalContext);
    const { setSnack } = context;
    const gaTracking = useGa();

    const login = useGoogleLogin({
        // onSuccess: codeResponse => console.log(codeResponse),
        onSuccess: tokenResponse => callback({...tokenResponse, provider: "google"}),
    });

    return (<>
        <button
            onClick={() => {
                gaTracking("login-google");
                login();
            }}
            className={className && className}
            style={sx}
        >
            {defaultIcon && <Icons icon="google" sx={{width: "18px", marginRight: "10px"}} />}{text}
        </button>
        {/* <GoogleLogin
            onSuccess={credentialResponse => {
                console.log(credentialResponse);
            }}
            onError={() => {
                console.log('Login Failed');
            }}
        />; */}
    </>)
}

export default GoogleLoginButton;
